import React, { useState } from "react";
import styles from './LiveSearch.module.scss';
import PropTypes from "prop-types";

const LiveSearch = ({
  placeholder = 'Search',
  onChange,
  className = ''
}) => {
  const [keyword, setKeyword] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={`${styles.searchGroup} ${className}`}>
      <div className={styles.iconWrapper}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z" stroke="#9E9E9E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <input 
        type="text"
        placeholder={placeholder}
        value={keyword}
        onChange={handleChange}
        className={styles.inputField}
      />
    </div>
  );
};

LiveSearch.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default LiveSearch;
